module.exports = __webpack_public_path__ + "static/img/team-member-3.eb5d4436.jpg";